import { PreferencesResponse, ProfileData } from 'modules/userPreferences/types';
import { ApiResponse, get, postForm } from 'services/api';
import { getXsrfToken } from 'utils/cookies';

export const PREFERENCES = '/i/preferences.json';
export const RESET_PASSWORD_URL = '/reset';

export const fetchUserPreferences = (): Promise<PreferencesResponse> => get(PREFERENCES);

export const updateUserPreferences = (
  payload: ProfileData,
  config = {},
): Promise<PreferencesResponse> => postForm(PREFERENCES, payload, config);

export const resetPassword = (payload: { email: string }): Promise<ApiResponse> =>
  postForm(RESET_PASSWORD_URL, { ...payload, csrfToken: getXsrfToken() });
